import React from 'react';
import { BaseLendingTileParams, BaseLendingTile } from '../BaseLendingTile';

import styles from './PlaceholderTile.module.scss';
import { LendingStatusBadgeEnum } from '../types';
import { LendingStatusBadge } from '../LendingBadge';

export type PlaceholderTileProps = Pick<
  BaseLendingTileParams,
  'financeSourceName' | 'financeImageUrl' | 'onClick' | 'isSelected' | 'height'
> & {
  rowOne?: string;
  rowTwo?: string;
};

export function PlaceholderTile({
  financeSourceName,
  financeImageUrl,
  rowOne,
  rowTwo,
  onClick,
  isSelected,
  height,
}: PlaceholderTileProps) {
  const statusBadge = (
    <LendingStatusBadge statusBadge={LendingStatusBadgeEnum.LOADING} />
  );

  const body = (
    <div className={styles.placeholderBody} data-testid="placeholder-tile-body">
      {rowOne && <div className={styles.rowOne}>{rowOne}</div>}
      {rowTwo && <div className={styles.rowTwo}>{rowTwo}</div>}
    </div>
  );

  return (
    <BaseLendingTile
      statusBadge={statusBadge}
      body={body}
      financeSourceName={financeSourceName}
      financeImageUrl={financeImageUrl}
      onClick={onClick}
      isSelected={isSelected}
      height={height}
    />
  );
}
